export const LOGIN_REDIRECTION_DELAY = 3000; // 3 seconds
